import { useEffect, useState } from "react";
import { LogOut, Building2, UserRound, Settings2 } from "lucide-react";
import { Toaster } from "../components/ui/sonner";
import { AuthProvider, useAuth } from "../components/admin/AuthContext";
import { AdminLogin } from "../components/admin/AdminLogin";
import { InboxTable } from "../components/admin/InboxTable";
import { SystemPanel } from "../components/admin/SystemPanel";
import { http } from "../lib/api";
import { useSeo } from "../lib/useSeo";

const TABS = [
  { id: "inquiries", label: "Arbeitgeberanfragen", icon: Building2 },
  { id: "applicants", label: "Bewerber", icon: UserRound },
  { id: "system", label: "System & Checkliste", icon: Settings2 },
];

const Dashboard = () => {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("inquiries");
  const [sys, setSys] = useState(null);
  useEffect(() => {
    http.get("/admin-system/status").then((r) => setSys(r.data)).catch(() => setSys(null));
  }, [tab]);

  return (
    <div className="container-x pt-[110px] pb-20" data-testid="admin-dashboard">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="eyebrow">Team-Bereich</p>
          <h1 className="mt-2 text-3xl font-bold text-[color:var(--navy)]">Eingänge</h1>
          <p className="mt-1 text-sm text-slate-600">Angemeldet als {user?.email}</p>
        </div>
        <button onClick={logout} className="inline-flex items-center gap-2 self-start rounded-full border border-slate-300 px-4 py-2 text-sm font-semibold" data-testid="admin-logout">
          <LogOut size={15} /> Abmelden
        </button>
      </div>
      <div role="tablist" className="mt-8 flex gap-2 overflow-x-auto pb-1">
        {TABS.map((t) => (
          <button key={t.id} role="tab" aria-selected={tab === t.id} onClick={() => setTab(t.id)} data-testid={`admin-tab-${t.id}`}
            className={`inline-flex shrink-0 items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold ${tab === t.id ? "bg-[color:var(--navy)] text-white" : "bg-slate-100 text-slate-700"}`}>
            <t.icon size={15} /> {t.label}
            {sys?.counts?.[t.id] !== undefined && <span className="rounded-full bg-white/20 px-2 text-xs">{sys.counts[t.id]}</span>}
          </button>
        ))}
      </div>
      <div className="mt-8">
        {tab === "system" ? <SystemPanel sys={sys} /> : <InboxTable key={tab} kind={tab} odooReady={!!sys?.odoo?.configured} />}
      </div>
    </div>
  );
};

const Gate = () => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-[70vh]" />;
  return user ? <Dashboard /> : <AdminLogin />;
};

export default function Admin() {
  useSeo("Team-Bereich", "Interner Bereich von PACTORA Personalpartner.", "/intern", true);
  return (
    <AuthProvider>
      <Gate />
      <Toaster position="top-right" />
    </AuthProvider>
  );
}
